export class ActualPayroll {

 
  public existingPayroll?: number;

  public constructionLabor?: number;
 
  //public newPayroll?: number;

}